export default "__VITE_ASSET__Bctu51QM__"